import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import PageShell, { PageHero } from "./PageShell";
import { solutionPages } from "../content/pages";
import { useUI } from "../context/UIContext";

import { tr } from "../i18n";
export default function SolutionPage() {
  const { slug } = useParams();
  const data = solutionPages[slug];
  const { openIllustration } = useUI();

  if (!data) return <Navigate to="/" replace />;

  return (
    <PageShell>
      <PageHero
        eyebrow={data.eyebrow}
        title={data.title}
        intro={data.intro}
        stat={data.stat}
      />
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-5xl mx-auto px-5 md:px-8">
          <div className="grid sm:grid-cols-2 gap-6">
            {data.benefits.map((b) => (
              <div
                key={b.title}
                className="rounded-2xl border border-[#0b1f3a]/8 bg-[#f6f2e9]/40 p-7"
              >
                <div className="w-10 h-10 rounded-full bg-[#0b1f3a] flex items-center justify-center mb-4">
                  <Check size={18} className="text-[#c2a15a]" />
                </div>
                <h3 className="font-display text-[22px] text-[#0b1f3a]">
                  {b.title}
                </h3>
                <p className="text-[#0b1f3a]/60 text-[15px] leading-relaxed mt-2">
                  {b.body}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-14 rounded-3xl bg-[#0b1f3a] p-8 md:p-12 text-center">
            <h3 className="font-display text-white text-[28px] md:text-[36px]">
              {tr("Ready to get started?")}
            </h3>
            <p className="text-white/60 mt-3 max-w-xl mx-auto">
              {tr("Request a tailored illustration — our team will guide you through every step.")}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
              <button
                onClick={openIllustration}
                className="inline-flex items-center justify-center border border-white/25 hover:border-[#c2a15a] text-white hover:text-[#c2a15a] font-medium uppercase tracking-wide text-[14px] px-7 py-4 rounded-full transition-colors"
              >
                {tr("Request an illustration")}
              </button>
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
